/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Body2Inputs */

const en_to_xml_body2 = /** @type {(inputs: To_Xml_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The convention here is the simplest defensible one. Every key becomes an element, never an attribute. Array items repeat the element name of the key that held them. A null value and an empty object both become a self closing element. The document is wrapped in a single root element and prefixed with an XML declaration, so what you copy out is a complete, parseable document rather than a fragment.`)
};

const ko_to_xml_body2 = /** @type {(inputs: To_Xml_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`여기서의 관례는 가장 단순하고 방어할 수 있는 것입니다. 모든 키는 요소가 되며 속성이 되는 일은 없습니다. 배열 항목은 그것을 담고 있던 키의 요소 이름을 반복합니다. null 값과 빈 객체는 모두 자기 종결 요소가 됩니다. 문서는 하나의 루트 요소로 감싸이고 XML 선언이 앞에 붙으므로, 복사해 가는 것은 조각이 아니라 완전하고 파싱 가능한 문서입니다.`)
};

const ja_to_xml_body2 = /** @type {(inputs: To_Xml_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ここでの慣習は最も単純で擁護できるものです。すべてのキーは要素になり、属性になることはありません。配列の項目は、それを保持していたキーの要素名を繰り返します。null の値と空のオブジェクトはどちらも自己終了要素になります。文書は 1 つのルート要素で包まれ XML 宣言が前に付くので、コピーして持ち出すのは断片ではなく完全でパース可能な文書です。`)
};

/**
* | output |
* | --- |
* | "The convention here is the simplest defensible one. Every key becomes an element, never an attribute. Array items repeat the element name of the key that hel..." |
*
* @param {To_Xml_Body2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_body2 = /** @type {((inputs?: To_Xml_Body2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Body2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_body2(inputs)
	if (locale === "ko") return ko_to_xml_body2(inputs)
	return ja_to_xml_body2(inputs)
});